import React from 'react';
import {
  GoogleReCaptchaContext,
  GoogleReCaptchaConsumerProps
} from '../../GoogleReCaptcha';

export const useGoogleReCaptchaContext = (): GoogleReCaptchaConsumerProps => React.useContext<GoogleReCaptchaConsumerProps>(GoogleReCaptchaContext);
